<div style="padding: 5%;">
    <div style="display: flex;justify-content: space-between;align-items: center;">
        <div style="font-size: 22px;font-family: var(--font);line-height: 1;padding: 10px 0px;">
            Want to delete the  Account {{data.name}} ?
        </div>
    </div>
    <div style="padding: 10px 0px;">
        <button class="confirm_button" (click)="ConfirmDelete()">Confirm</button>
   
        <button class="confirm_button" (click)="closeAccountDialog()">Cancel</button>
    </div>
    
</div>